<script>
  import { format } from 'svelte-i18n';
  import { Button, Table } from '@sveltestrap/sveltestrap';

  import { ShowMore } from '@client/components/show-more';
  import { Spinner } from '@client/components/spinner';

  export let data = [];
  export let onAddUser = () => {};
  export let onAddDomain = () => {};
  export let selectedDomains = [];
  export let users = '';
  export let loading = false;
</script>

{#if loading}
  <div class="loading mt-3">
    <div class="spinner">
      <Spinner show inline />
    </div>
  </div>
{:else if data.length}
  <ShowMore
    collapsedText={$format('label.SHOW_ASSOCIATIONS')}
    expandedText={$format('label.HIDE_ASSOCIATIONS')}
    class="mt-3"
    expanded
  >
    <div class="assignments">
      <p>{$format('label.ASSOCIATIONS')} ({data.length.toLocaleString()})</p>

      <div class="assignments-table">
        <Table size="sm" class="m-0">
          <thead>
            <tr>
              <th>{$format('label.USER')}</th>
              <th>{$format('label.DOMAIN')}</th>
              <th class="text-nowrap">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {#each data as domain}
              <tr>
                <td>{domain.email}</td>
                <td tyle="text-break-all">{domain.domainname}</td>
                <td class="text-nowrap">
                  {#if users?.indexOf(domain.email) === -1}
                    <Button size="sm" color="secondary" on:click={() => onAddUser(domain.email)}>Add User</Button>
                  {/if}

                  {#if (users?.indexOf(domain.domainname) === -1 && !selectedDomains?.length) || selectedDomains?.find(({ value }) => value !== domain.domainname)}
                    <Button size="sm" color="secondary" on:click={() => onAddDomain(domain.domainname)}
                      >Add Domain</Button
                    >
                  {/if}
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>
    </div>
  </ShowMore>

  <hr />
{/if}

<style lang="scss">
  p {
    font-weight: var(--font-weight-medium);
    margin: var(--margin-large) 0 var(--margin-base);
  }

  .loading {
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-base);
    max-height: 200px;
    overflow: auto;
    padding: var(--padding-large);
  }

  .assignments {
    margin: var(--margin-large) 0;

    .assignments-heading {
      font-weight: var(--font-weight-medium);
      margin-bottom: var(--margin-base);
    }

    .assignments-table {
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-base);
      max-height: 200px;
      overflow: auto;

      .text-word-break {
        word-break: all;
      }
    }
  }
</style>
